import Quill from 'quill';
import { Delta } from '@vueup/vue-quill';
import * as QuillConverter from 'quill-delta-to-html';

import { paginateText } from "@/common/utils/text";

export function quillDeltaToHtml(deltaObj: any) {
    const converter = new QuillConverter.QuillDeltaToHtmlConverter(deltaObj.ops, {});

    return converter.convert();
}

export function paginateDelta(delta: any, style: {
    height: number;
    initial_height?: number;
    font_size: string;
    font_family: string;
    font_weight: string;
    line_height: string;
    text_align: string;
    width: string;
}) {
    const { ops } = delta;

    if (!ops || ops.length === 0) {
        return [];
    }

    const pages: {
        height: number;
        ops: any[];
    }[] = [];

    // Extrai todo o texto simples dos ops para paginar
    const totalText = ops.map((op: any) =>
        typeof op.insert === 'string' ? op.insert : ''
    ).join("");

    // Pagina texto puro
    const paginatedText = paginateText(totalText, {
        height: style.height,
        initial_height: style.initial_height,
        font_size: style.font_size,
        font_family: style.font_family,
        font_weight: style.font_weight,
        line_height: style.line_height,
        text_align: style.text_align,
        width: style.width,
    });

    if (paginatedText.length === 0) return [];

    // Inicializa páginas com altura correta (considerando initial_height)
    paginatedText.forEach((page, index) => {
        const isFirstPage = index === 0;
        const initialH = isFirstPage ? (style.initial_height ?? 0) : 0;

        pages[index] = {
            height: initialH + page.height,
            ops: []
        };
    });

    // Distribuição dos ops seguindo as quebras reais
    let currentPageIndex = 0;
    let currentPageTextOffset = 0;

    ops.forEach((op: any) => {
        if (typeof op.insert !== "string") {
            // Inserções não textuais seguem a página atual
            pages[currentPageIndex]?.ops.push(op);
            return;
        }

        let remaining = op.insert;

        while (remaining.length > 0 && currentPageIndex < paginatedText.length) {
            const pageText = paginatedText[currentPageIndex].text;
            const pageMaxLen = pageText.length;

            // Quanto ainda cabe nesta página
            const available = pageMaxLen - currentPageTextOffset;

            if (available <= 0) {
                // Ir para próxima página
                currentPageIndex++;
                currentPageTextOffset = 0;
                continue;
            }

            const chunk = remaining.substring(0, available);

            if (chunk.length > 0) {
                pages[currentPageIndex].ops.push({
                    ...op,
                    insert: chunk
                });

                currentPageTextOffset += chunk.length;
                remaining = remaining.substring(chunk.length);
            }

            if (currentPageTextOffset >= pageMaxLen) {
                currentPageIndex++;
                currentPageTextOffset = 0;
            }
        }
    });

    // Remove páginas sem conteúdo
    return pages.filter(p => p.ops.length > 0);
}